import React, { useEffect, useRef } from "react";
import supportCallImg1 from "../assets/supportimgfin1.png";
import supportCallImg2 from "../assets/supportimgfin2.png";

const Renderads = ({ imgNumber }) => {
  const adRef = useRef(null);
  let selectedImg = imgNumber === 2 ? supportCallImg2 : supportCallImg1;

  // Smooth fade animation
  useEffect(() => {
    const el = adRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) el.classList.add("fade-visible");
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
  }, []);

  return (
    <div
      ref={adRef}
      className="
        md:hidden fade-section 
        w-full mb-6
      "
    >
      {/* TOP STRIP */}
      <div className="text-center bg-gradient-to-r from-teal-600 to-teal-500 text-white font-semibold rounded-t-xl py-2">
        Special Phone-Only Deals
      </div>

      {/* CENTER IMAGE */}
      <img
        src={selectedImg}
        alt="Support"
        className="
          w-full 
          
          mx-auto 
          mt-3 
          rounded-xl 
          shadow-lg
          object-fill
        "
      />

      {/* BOTTOM STRIP */}
      <div className="text-center bg-gradient-to-r from-gray-800 to-gray-700 text-white font-medium rounded-b-xl py-2">
        24×7 Travel Assistance
      </div>

      {/* CALL BOX */}
      <div
        className="
          bg-white 
          border border-gray-200 
          rounded-2xl 
          shadow-md 
          mt-4 
          px-4 
          py-5 
          text-center
        "
      >
        <p className="text-gray-700 text-sm leading-relaxed">
          Speak with a live travel expert for{" "}
          <span className="font-bold text-teal-600">exclusive phone-only fares.</span>
        </p>

        <a
          href="tel:+18887112909"
          className="
            mt-4 inline-flex items-center justify-center
            bg-teal-600 hover:bg-teal-700
            text-white font-bold
            px-6 py-2
            rounded-full
            shadow-lg
            transition-all duration-300
            text-lg
            w-full
          "
        >
          Call Now: +1 888-711-2909
        </a>

        <p className="mt-3 text-[13px] text-gray-600 font-medium">
          Limited-time offers — Call Today
        </p>
      </div>
    </div>
  );
};

export default Renderads;
